import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ css }) => {
  return {
    playerContainer: css`
      position: fixed;
      bottom: 0;
      right: 0;
      width: calc(100% - 280px);
    `
  }
})
